import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImageUrlPipe } from './image-url.pipe';
import { MediaImageComponent } from './media-image/media-image.component';



@NgModule({
  declarations: [
    MediaImageComponent,
  ],
  imports: [
    CommonModule,
    ImageUrlPipe,
  ],
  exports: [
    MediaImageComponent,
  ]
})
export class ImagesModule { }
